module.exports = __webpack_public_path__ + "img/trash-can-outline.8df7ecc0.svg";